import thumbnail1 from '../../assets/images/projects/project-1.webp';
import thumbnail2 from '../../assets/images/projects/project-2.webp';
import thumbnail3 from '../../assets/images/projects/project-3.webp';
import thumbnail4 from '../../assets/images/projects/project-4.webp';
import thumbnail5 from '../../assets/images/projects/project-5.webp';
import thumbnail6 from '../../assets/images/projects/project-6.webp';
import thumbnail7 from '../../assets/images/projects/project-7.webp';
import thumbnail8 from '../../assets/images/projects/project-8.webp';
import thumbnail9 from '../../assets/images/projects/project-9.webp';
import thumbnail10 from '../../assets/images/projects/project-10.webp';
import thumbnail11 from '../../assets/images/projects/project-11.webp';


const response =  {
    "status": 200,
    "message": "OK",
    "data": [
        {
            "id": 1,
            "thumbnail": thumbnail1,
            "title": "Rest API and Admin Dashboard Jakarta Marathon 2022",
            "categories": ["Laravel", "PHP", "Bootstrap"],
            "source": null,
            "preview": "https://jakmar.socyolo.com"
        },
        {
            "id": 2,
            "thumbnail": thumbnail2,
            "title": "Rest API and Admin Dashboard Yukita App",
            "categories": ["Laravel", "PHP", "Bootstrap"],
            "source": null,
            "preview": "https://play.google.com/store/apps/details?id=com.yukita"
        },
        {
            "id": 3,
            "thumbnail": thumbnail3,
            "title": "School Fintech Full Feature Template",
            "categories": ["Laravel", "Bootstrap", "Javascript"],
            "source": "https://github.com/darektoa/school-fintech-template",
            "preview": "http://103.247.219.36:803/"
        },
        {
            "id": 4,
            "thumbnail": thumbnail4,
            "title": "Laravel Component Admin Template",
            "categories": ["Laravel", "Bootstrap", "Javascript"],
            "source": "https://github.com/darektoa/sb-admin-2-component",
            "preview": null
        },
        {
            "id": 5,
            "thumbnail": thumbnail5,
            "title": "Kampoeng Cireundeu Tasikmalaya Profile Website",
            "categories": ["ReactJs", "HTML", "CSS"],
            "source": "https://github.com/darektoa/",
            "preview": "https://village-website.vercel.app/"
        },
        {
            "id": 6,
            "thumbnail": thumbnail6,
            "title": "Indodesign Company Profile Website",
            "categories": ["Wordpress", "HTML", "CSS"],
            "source": "https://github.com/darektoa/indodesign",
            "preview": "https://indodesign.vercel.app/"
        },
        {
            "id": 7,
            "thumbnail": thumbnail7,
            "title": "Gmail Landing Page Clone - 98% Identical",
            "categories": ["ReactJs", "HTML", "CSS"],
            "source": "https://github.com/darektoa/clone-gmail-home",
            "preview": "https://gmail-home.vercel.app/"
        },
        {
            "id": 8,
            "thumbnail": thumbnail8,
            "title": "Generasi Cuan Profile Website",
            "categories": ["PWA", "Javascript", "HTML", "CSS"],
            "source": "https://github.com/darektoa/generasi-cuan",
            "preview": "https://gen-cuan.web.app/"
        },
        {
            "id": 9,
            "thumbnail": thumbnail9,
            "title": "Rexam Web App- Rexensoft Exam",
            "categories": ["PWA", "Javascript", "HTML", "CSS"],
            "source": "https://github.com/darektoa/rexam",
            "preview": "https://rexam.vercel.app/#/dashboard"
        },
        {
            "id": 10,
            "thumbnail": thumbnail10,
            "title": "Frests Web App - Finding Restaurants",
            "categories": ["PWA", "Javascript", "HTML", "CSS"],
            "source": "https://github.com/darektoa/rexam",
            "preview": "https://rexam.vercel.app/#/dashboard"
        },
        {
            "id": 11,
            "thumbnail": thumbnail11,
            "title": "Rexballs Web App - Football Standings",
            "categories": ["PWA", "Javascript", "HTML", "CSS"],
            "source": "https://github.com/darektoa/rexballs",
            "preview": "https://rexballs.web.app/#liga-inggris"
        }
    ]
}

export default response;